'use client'

import { cn } from '@/lib/utils'

export type ShareRoomCommunityStepNavProps = {
  currentStep: number
}

export function ShareRoomCommunityStepNav({ currentStep }: ShareRoomCommunityStepNavProps) {
  return (
    <nav aria-label="Invite steps" className="flex shrink-0 flex-wrap items-center justify-center gap-2 border-b border-slate-100 pb-4 text-xs text-slate-500">
      {[
        { step: 1, label: 'Audience' },
        { step: 2, label: 'Add people' },
        { step: 3, label: 'Review & send' },
      ].map(({ step, label }, i) => (
        <div key={step} className="flex items-center gap-2">
          <span
            className={cn(
              'flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold',
              currentStep >= step ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-500'
            )}
          >
            {step}
          </span>
          <span className={cn('hidden font-medium sm:inline', currentStep === step && 'text-slate-900')}>{label}</span>
          {i < 2 && (
            <span className="hidden text-slate-300 sm:inline" aria-hidden>
              →
            </span>
          )}
        </div>
      ))}
    </nav>
  )
}
